// Pure feature-gating resolution. No React. Mirrors backend plan_features.py.
// null/undefined  → not loaded yet (legacy/offline, pre-login) → default-open.
// []              → loaded but empty (Basic tenant)            → gates everything.
// ['inventory', …] → loaded with flags                        → real membership check.
// The backend is the authoritative gate; this only governs UI affordances.

export function hasFeature(enabledFeatures, flag) {
  // Not loaded yet (null/undefined) → default-open for legacy/offline pre-payload sessions.
  // A loaded array (including an empty [] for a Basic tenant) → real membership check.
  if (enabledFeatures == null) return true;
  return enabledFeatures.includes(flag);
}

export function getLimit(limits, key) {
  if (!limits || !(key in limits)) return null; // null = unlimited
  return limits[key];
}

export function isUnlimited(limits, key) {
  return getLimit(limits, key) === null;
}

export function atLimit(limits, key, currentCount) {
  const cap = getLimit(limits, key);
  if (cap === null) return false;
  return currentCount >= cap;
}
